import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Obrigado = () => {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5 flex items-center justify-center p-4">
      <div className="max-w-lg w-full text-center space-y-8">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center animate-in zoom-in duration-500">
            <CheckCircle className="w-12 h-12 text-primary" />
          </div>
        </div>

        {/* Main Message */}
        <div className="space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground animate-in fade-in slide-in-from-bottom-4 duration-700">
            Obrigado! 🎉
          </h1>
          
          <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-150">
            <p className="text-xl text-foreground font-medium">
              Formulário enviado com sucesso!
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Em breve nosso time irá entrar em contato com você para dar continuidade ao processo.
            </p>
          </div>

          <div className="pt-6 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-300">
            <Button 
              onClick={() => navigate('/')}
              size="lg"
              className="min-w-[200px]"
            >
              Voltar para o início
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
};
export default Obrigado;